"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var reselect_1 = require("reselect");
var constants_1 = require("@gin-betting/constants");
var appServiceLocator_1 = __importDefault(require("../appServiceLocator"));
var getBettingOptions_1 = __importDefault(require("../utils/getBettingOptions"));
var selectors_1 = require("../entities/selectors");
var types_1 = require("../types");
function useGridEmbedVideoToken(_a) {
    var matchId = _a.matchId, isGridPlayer = _a.isGridPlayer;
    var _b = react_1.useState({
        seriesId: '',
        token: '',
    }), gridEmbedVideoToken = _b[0], setGridEmbedVideoToken = _b[1];
    var _c = react_redux_1.useSelector(function (state) {
        return selectMatchProps(state, {
            matchId: matchId,
        });
    }), isCounterStrike = _c.isCounterStrike, isLive = _c.isLive;
    var isAuthorized = getBettingOptions_1.default().isAuthorized;
    react_1.useEffect(function () {
        if (!isAuthorized || !isCounterStrike || !isGridPlayer || !isLive) {
            return;
        }
        var apiClient = appServiceLocator_1.default.get('apiClient');
        apiClient
            .makeRequest({
            method: 'generateGridEmbedVideoToken',
            variables: {
                sportEventId: matchId,
            },
        })
            .then(function (_a) {
            var data = _a.data;
            if (!data)
                return;
            setGridEmbedVideoToken(data.generateGridEmbedVideoToken);
        })
            .catch(function (err) {
            console.error(err);
        });
    }, [isAuthorized, isCounterStrike, isGridPlayer, isLive, matchId]);
    return {
        gridEmbedVideoToken: gridEmbedVideoToken,
    };
}
var selectMatchProps = reselect_1.createSelector(selectors_1.selectMatch, function (match) {
    if (!match)
        return {};
    return {
        isCounterStrike: match.sportId === constants_1.Sports.ESPORTS_COUNTER_STRIKE,
        isLive: [
            types_1.GQL.SportEventStatus.LIVE,
            types_1.GQL.SportEventStatus.SUSPENDED,
        ].includes(match.status),
    };
});
exports.default = useGridEmbedVideoToken;
//# sourceMappingURL=useGridEmbedVideoToken.js.map